import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { ListDTO, ListResponseAPI } from 'src/lib/queries';
import { VoucherType } from 'src/features/voucherTypes/utils/types';

const RESOURCE = '/discounts/voucher-type/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    is_active?: boolean;
    has_reached_limit?: boolean;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<VoucherType>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_VOUCHER_TYPES_RESOURCE, useQueryHook as useListVoucherTypes };
